import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import map from 'lodash/map';
import { FormattedMessage } from 'react-intl';

import Mission from 'models/task/Mission';
import TaskState from 'models/task/state/TaskState';

//import SVGImage from 'components/commons/SVGImage';

import { Currency } from 'components/_/common/currency/Currency';
import { ProgressBar } from 'components/_/common/progress-bar/ProgressBar';

const Element = ({ task: _task }) => {
	const [isVisible, setVisible] = useState(false);

	function open(event) {
		if (event) {
			event.preventDefault();
		}

		setVisible(true);
	}

	function close(event) {
		if (event) {
			event.preventDefault();
		}

		setVisible(false);
	}

	const isUnavailable = _task.state().status(_task) === TaskState.STATUS_UNAVAILABLE;

	return (
		<div className="col-24">
			<div className="mx-0 mx-sm-3">
				<NavLink
					to={isUnavailable ? '#' : `/${_task instanceof Mission ? 'mission' : 'task'}/${_task.id()}/details`}
					onClick={event => isUnavailable && event.preventDefault()}
					className={classnames('position-relative d-block', {
						[`task--${_task.state().status(_task)}`]: true,
					})}
				>
					<div className="collectionMission__listRow d-flex py-3 py-sm-0 fs-4">
						<div className="d-flex align-items-center">
							<div className="listRow__status px-3 px-sm-5 py-3">
								<div
									className="task__status rounded-circle"
									onMouseEnter={() => open()}
									onMouseLeave={() => close()}
								>
									{isUnavailable && isVisible && (
										<div className="d-flex tooltip">
											<div className="tooltip__content position-absolute shadow p-3 rounded">
												{_task.startAt() && _task.startAt().isAfter() ? (
													<FormattedMessage
														id={`task-details.collection-mission.content.availability.available-from`}
														values={{
															date: _task.startAt().format('L'),
														}}
													/>
												) : null}
												{_task.endAt() && _task.endAt().isBefore() ? (
													<FormattedMessage
														id={`task-details.collection-mission.content.availability.unavailable`}
													/>
												) : null}
											</div>
										</div>
									)}
								</div>
							</div>
							{/*<div className="listRow__icon pr-3 pr-sm-5">
								{_task.icon() && <SVGImage src={_task.icon()} className="icon mr-2 mr-xs-3" />}
							</div>*/}
						</div>
						<div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center flex-grow-1">
							<div className="listRow__name pr-0 pr-sm-5 flex-grow-1 order-1 order-sm-1">
								{_task.name()}
							</div>
							{_task instanceof Mission && (
								<div className="listRow__progressBar d-block d-sm-flex pt-2 pt-sm-0 pr-0 pr-sm-5 order-3 order-sm-2 flex-grow-1">
									<p className="mr-3 d-none d-sm-block">Twój postęp w misji</p>
									<ProgressBar
										progress={_task.state().progress() * 100}
										tooltip={true}
										className="align-self-center flex-grow-1"
									/>
								</div>
							)}
							{_task.state().hasCompletionEarnings() && _task.state().showPoints(_task) && (
								<div className="listRow__points d-flex align-items-center px-0 px-sm-3 pt-2 py-sm-5 order-2 order-sm-3 rounded-right">
									{map(_task.earningsInformation().completion.values(), currency => (
										<Currency
											key={currency.codeName()}
											currency={currency.codeName()}
											value={currency.value()}
											className="mr-4 mx-sm-3"
										/>
									))}
								</div>
							)}
						</div>
					</div>
				</NavLink>
			</div>
		</div>
	);
};

export const CollectionList = ({ task }) => {
	return (
		<div className="collectionMission__rowList flex-grow-1 my-2 my-sm-0">
			<div className="row">
				{task.tasks().map(_task => (
					<Element key={_task.id()} task={_task} />
				))}
			</div>
		</div>
	);
};
